import React, { useEffect, ReactNode } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectIsAuthenticated, selectUserRole } from "../slice/authSlice";
import { checkTokenValidity } from "../slice/authSlice";
import { useAppDispatch } from "../redux/store";
import { all_routes } from "../../../feature-module/router/all_routes";

interface AuthMiddlewareProps {
  children?: ReactNode;
  allowedRoles?: string[];
}

const AuthMiddleware: React.FC<AuthMiddlewareProps> = ({
  children,
  allowedRoles,
}) => {
  const dispatch = useAppDispatch();
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const userRole = useSelector(selectUserRole) ?? "";
  const location = useLocation();
  const routes = all_routes;

  // Check if screen is locked
  const isScreenLocked = sessionStorage.getItem("isScreenLocked") === "true";

  useEffect(() => {
    // Check token validity on mount and when location changes
    dispatch(checkTokenValidity() as any);
  }, [dispatch, location.pathname]);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // If screen is locked and not already on lock screen, redirect to lock screen
  if (isScreenLocked && location.pathname !== routes.lockScreen) {
    return <Navigate to={routes.lockScreen} replace />;
  }

  if (allowedRoles && userRole && !allowedRoles.includes(userRole)) {
    console.log("Access denied for", userRole, "to", location.pathname);
    return <Navigate to="/unauthorized" replace state={{ from: location }} />;
  }

  return children ? <>{children}</> : <Outlet />;
};

export default AuthMiddleware;
